import React from 'react';
import style from './line.module.scss';

function PackageAiLine({ className = '' }) {
  return <div className={`${style.line} ${className}`} />;
}

export default PackageAiLine;
